export default "__VITE_ASSET__DziJi2hF__"